'use strict';

exports.__esModule = true;
exports.jobMethods = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.Job = Job;

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

var _waypoint = require('./waypoint');

var _waypoint2 = _interopRequireDefault(_waypoint);

var _order = require('./order');

var _order2 = _interopRequireDefault(_order);

var _orders = require('../customer/orders');

var _orders2 = _interopRequireDefault(_orders);

var _waypoints = require('../customer/waypoints');

var _waypoints2 = _interopRequireDefault(_waypoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DROPOFF = 'dropoff';
var PICKUP = 'pickup';
var RETURN = 'return';

var jobMethods = exports.jobMethods = {
  // returns promise with updated job
  createOrder: function createOrder() {
    var _this = this;

    return _orders2.default.create({
      jobId: this.id
    }).then(function (order) {
      _this.orders.push(order);
      return _this;
    });
  },


  // returns promise with updated job
  createWaypointsPair: function createWaypointsPair() {
    var _this2 = this;

    var orderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getLastOrderId(this);

    return _waypoints2.default.createPair({
      jobId: this.id,
      waypoint: {
        orderId: orderId
      }
    }).then(function (waypoints) {
      _this2.waypoints = _this2.waypoints.concat(waypoints);
      return _this2;
    });
  },


  // Returns true if the job is scheduled in the future
  scheduledForFuture: function scheduledForFuture() {
    return !!this.scheduledFor && Date.parse(this.scheduledFor) > new Date().getTime();
  }
};

function Job(attr) {
  if (!_config2.default.models) {
    return attr;
  }

  var id = attr.id,
      totalCost = attr.totalCost,
      _attr$orders = attr.orders,
      orders = _attr$orders === undefined ? [] : _attr$orders,
      _attr$waypoints = attr.waypoints,
      waypoints = _attr$waypoints === undefined ? [] : _attr$waypoints,
      others = (0, _objectWithoutProperties3.default)(attr, ['id', 'totalCost', 'orders', 'waypoints']);


  return (0, _extends3.default)({
    __proto__: jobMethods,
    id: id,
    displayId: createDisplayId(id),
    totalCost: parsePrice(totalCost),
    orders: orders.map(_order2.default),
    waypoints: createWaypoints(waypoints),
    get pickups() {
      return this.waypoints.filter(function (waypoint) {
        return waypoint.waypointType === PICKUP;
      });
    },
    get dropoffs() {
      return this.waypoints.filter(function (waypoint) {
        return waypoint.waypointType === DROPOFF;
      });
    },
    get returns() {
      return this.waypoints.filter(function (waypoint) {
        return waypoint.waypointType === RETURN;
      });
    }
  }, others);
}

function getLastOrderId(job) {
  return job.orders[job.orders.length - 1].id;
}

function parsePrice(price) {
  return typeof price !== 'undefined' ? parseFloat(price) : -1;
}

function createDisplayId(id) {
  return typeof id === 'string' && id.indexOf('-') > -1 ? id.split('-')[1] : '';
}

function createWaypoints(waypoints) {
  waypoints.map(_waypoint2.default);
  return waypoints;
}

exports.default = Job;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/models/job.js
// module id = 1077
// module chunks = 0